// 手机号码-国内
export function validatePhone(value) {
  return /^1[3456789]\d{9}$/.test(value);
}

// 国外手机号码
export function validateAllPhone(value) {
  return /^[0-9]\d{6,11}$/.test(value);
}

// 数字
export function validateNumber(rule, value, callback) {
  if (value === '') {
    callback();
  } else if (!/^\d+$/.test(value)) {
    callback(new Error('请输入数字'));
  } else {
    callback();
  }
}
//匹配特殊字符
export function testSpecialStr(val) {
  // return /[`~!@#$%^*()_+?:{},.\/;[\]]/.test(val) && /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/.test(val)
  return /[^\u4e00-\u9fa5a-zA-Z0-9]/g.test(val)
}



// WEBPACK FOOTER //
// ./src/utils/validate.js